import React, { useContext, useEffect } from "react";

import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";

import LanguageContext from "../LanguageContext";
import messages from "../services/messages";
import firebase from "../firebase";
import UserService from "../services/UserService";
import Skeleton from '@mui/material/Skeleton';
import config from "../config";
import SectionTitle from "./SectionTitle";

const useStyles = makeStyles((theme) => ({
  cropAvatar: {
    // marginRight: theme.spacing(3.2),
    marginBottom: theme.spacing(1),
  },
  cropImage: {
    marginBottom: theme.spacing(1),
  },
  loader: {
    marginLeft: "-1.2em",
  },
  contentCard: {
    marginLeft: theme.spacing(2),
  },
  cropsContainer: {
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    padding: theme.spacing(0, 1),
    marginTop: theme.spacing(1),
  },
  cropsCardWrapper: {
    flex: "0 0 auto",
  },
  cropThumbnail: {
    width: theme.spacing(11),
    height: theme.spacing(11),
  },
  root: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(0),
  },
  title: {},
  showMoreAvatar: {
    width: theme.spacing(11),
    height: theme.spacing(11),
    cursor: "pointer",
    background: "#FFFFFF",
  },
  showMoreAvatarImg: {
    height: "20px",
    width: "30px",
  },
  showMoreAvatarContainer: {
    display: "flex",
    flexDirection: "column",
  },
  showMoreText: {
    marginTop: theme.spacing(2),
  },
  cropVideosCount: {
    color: "#999999",
    fontSize: "12px",
    fontWeight: 400,
  },
  playButtonBase: {
    top: theme.spacing(-10.5),
    left: "30%",
    marginBottom: theme.spacing(-8.5),
  },
  playButton: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    opacity: "0.9",
    // left: "30%",
    position: "absolute",
    // top: 0,
    // left: 0,
    marginTop: theme.spacing(-3.8),
    marginLeft: theme.spacing(7.3),
  },
}));

export default function CropsListContainer(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);
  const [mobile, setMobile] = React.useState(null);
  const [cropName, setCropName] = React.useState(null);
  const [visible, setvisible] = React.useState(11);
  let visibleno = 12; //one more than the visible
  const [userState, setUserState] = React.useState(
    localStorage.getItem("state")
  );
  let usertype = localStorage.getItem("premium");
  // const [open, setOpen] = React.useState(true);

  // const handleClick = () => {
  //   setOpen(!open);
  // };

  const handleShow = () => {
    let numberOfVisibleCrops = 12; //one more than the visible

    if (props.cropList.length - visible >= visibleno) {
      numberOfVisibleCrops = visible + visibleno;
      setvisible(numberOfVisibleCrops);
      visibleno++;
    } else {
      numberOfVisibleCrops = visible + (props.cropList.length % visible);
      setvisible(numberOfVisibleCrops);
    }

    firebase.analytics().logEvent("crops_list_show_more_clicked", {
      mobile,
      state: props.userState.name_en,
      user_type: props.userType,
      farmer_crops: JSON.stringify(props.farmerCrops),
      visible_crops_count: numberOfVisibleCrops,
      user_source: props?.userSource,
    });
  };

  useEffect(() => {
    const userInfo = UserService.getUserInfo();
    if (userInfo) {
      setMobile(userInfo.mobile);
    }
  }, []);

  return (
    <Container className={classes.root}>
      <SectionTitle
        title={messages["dashboard.cropsList.title"][language]}
        icon={"icons/crop-recorded.svg"}
        userSource={props?.userSource}
      />

      {props.loading && (
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          wrap={"wrap"}
          spacing={2}
        >
          <Grid item>
            <Skeleton
              variant="circular"
              className={classes.cropAvatar}
              width={72}
              height={72}
            />
          </Grid>
          <Grid item>
            <Skeleton
              variant="circular"
              width={72}
              height={72}
              className={classes.cropAvatar}
            />
          </Grid>
          <Grid item>
            <Skeleton
              variant="circular"
              width={72}
              height={72}
              className={classes.cropAvatar}
            />
          </Grid>
        </Grid>
      )}
      {props.cropList && props.cropList.length > 0 && (
        <div className={classes.cropsContainer}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            wrap={"wrap"}
            className={classes.cropsCardWrapper}
            spacing={1}
          >
            {props?.cropList?.slice(0, visible).map((crop, index) => {
              return (
                <Grid
                  item
                  xs={4}
                  sm={3}
                  lg={1}
                  key={index}
                  className={classes.cropAvatar}
                >
                  <a
                    href={`/crop/${crop.name_en}`}
                    style={{ textDecoration: "none", color: "#212121" }}
                    onClick={() => {
                      firebase.analytics().logEvent("crop_clicked", {
                        mobile,
                        crop_name: crop.name_en,
                        page_name: window.location.pathname,
                        position: index + 1,
                        state: props.userState.name_en,
                        user_type: props.userType,
                        videos_count: crop.total_videos_count
                          ? crop.total_videos_count
                          : 0,
                        farmer_crops: JSON.stringify(props.farmerCrops),
                        user_source: props?.userSource,
                      });
                    }}
                  >
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      className={classes.cropImage}
                    >
                      <Grid item>
                        <Avatar
                          aria-label="author"
                          src={`${
                            config.gcpBucketBase
                          }content${encodeURIComponent(
                            crop.image_thumbnail
                          )}?alt=media`}
                          style={{
                            backgroundColor: `${crop.color}`,
                          }}
                          className={classes.cropThumbnail}
                        ></Avatar>
                        <img
                          src="../../icons/play-with-shadow.svg"
                          alt="play"
                          className={classes.playButton}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography variant={"subtitle2"}>
                          {crop[`name_${language}`]}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography
                          variant="subtitle2"
                          className={classes.cropVideosCount}
                        >
                          {crop.total_videos_count
                            ? `${crop.total_videos_count} ${messages["cropPage.cropHeader.videosCountTitle"][language]}`
                            : ""}
                        </Typography>
                      </Grid>
                    </Grid>
                  </a>
                </Grid>
              );
            })}
            {visible !== props?.cropList?.length &&
            props?.cropList?.length !== 0 ? (
              <Grid item xs={4} sm={3} lg={1} className={classes.cropAvatar}>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  className={classes.cropImage}
                >
                  <Grid item>
                    <Avatar
                      src="/icons/Vector.svg"
                      onClick={handleShow}
                      classes={{
                        root: classes.showMoreAvatar,
                        img: classes.showMoreAvatarImg,
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid item>
                    <Typography variant={"subtitle2"}>
                      {messages["dashboard.cropsList.showMore"][language]}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        </div>
      )}
    </Container>
  );
}
